<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iG7DCH/tc-custom/9781540260796.jpg?1719575728552" alt="This image is the cover for the book Hot Rodding in the San Fernando Valley, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hot Rodding in the San Fernando Valley, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>This book chronicles the once-vibrant hot rod scene in California's San Fernando Valley--from the iconic Bob's Big Boy drive-in to the San Fernando drag strip.  Author and Los Angeles native, Tony Baker, grew up in Hollywood during the height of the sixties hot-rod scene. He has written six books on the subject of motor sports in California for Arcadia Publishing and has had articles published in Hot Rod magazine, Hot Rod Deluxe , and Rodder's Journal as well as regional history publications like the Ventura County Historical Society Quarterly Journal . He currently lives in Ventura, California.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mr. Tony T. Baker
      </h2>
      
      <p class="authorDescription body article">Los Angeles native Tony Baker grew up in Hollywood during the height of the sixties hot-rod scene. He has written six books on the subject of motor sports in California for Arcadia Publishing and has had articles published in Hot Rod magazine, Hot Rod Deluxe , and Rodder's Journal as well as regional history publications like the Ventura County Historical Society Quarterly Journal . He currently lives in Ventura, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?31f336f4